import { render, staticRenderFns } from "./roleDialogyh.vue?vue&type=template&id=75a234f1&"
import script from "./roleDialogyh.vue?vue&type=script&lang=js&"
export * from "./roleDialogyh.vue?vue&type=script&lang=js&"
import style0 from "./roleDialogyh.vue?vue&type=style&index=0&id=75a234f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports